// extracted by mini-css-extract-plugin
export var container = "QuickFacts-module--container--f6972";
export var layout = "QuickFacts-module--layout--648cf";
export var wrapper = "QuickFacts-module--wrapper--e47cc";
export var item = "QuickFacts-module--item--912b4";
export var count = "QuickFacts-module--count--9fb10";